import { apiCommonTrigger } from "../Utils/apiServicehelper";
import { Config } from "../Utils/Config";
import ConstantData from "../Utils/Constant";

export function isValidUrl(urlString) {
    try {
      new URL(urlString);
      return true;  // URL is valid
    } catch (e) {
      return false;  // URL is not valid
    }
}

export function getImageSrc(base64String) {
  if (!base64String) return null; // Handle empty or undefined data

  // Try to detect the MIME type (Assuming first part of Base64 string contains it)
  const mimeType = base64String.charAt(0) === '/' ? 'image/jpeg' :
    base64String.charAt(0) === 'i' ? 'image/png' :
      base64String.charAt(0) === 'R' ? 'image/gif' :
        base64String.charAt(0) === 'U' ? 'image/webp' :
          'image/png'; // Default fallback

  return(`data:${mimeType};base64,${base64String}`);
};

export function developmentSeperation(response , setKnowndataArr , setNoDataOfKnownData , setWidgetData ,  isDetailed= false){
  var widgetData = null;
    var knowndata = [];
    let noDataOfKnownData;
  if (response.developmentDetails?.length > 0) {
    knowndata = JSON.parse(
      JSON.stringify(response.developmentDetails).replace(/:null/gi, ':""')
    );
    var nf = new Intl.NumberFormat();
    knowndata.map(function (know_data, index) {
      know_data.buildingsqft =
        know_data?.buildingsqft
          ? nf.format(know_data.buildingsqft)
          : "-";
      know_data.noofunits =
        know_data?.noofunits ? nf.format(know_data.noofunits) : "-";
      know_data.estimatevalue =
        know_data?.estimatevalue
          ? nf.format(know_data.estimatevalue)
          : "-";
      know_data.estimatedrentablesquarefootage = know_data?.estimatedrentablesquarefootage ? nf.format(know_data.estimatedrentablesquarefootage) : "-";
      know_data.salespricing = know_data?.salespricing ? Config.Currency + nf.format(know_data.salespricing) : "-";
      return know_data;
    });
    let knowndataArr = [...knowndata];
    if(!isDetailed) setKnowndataArr(knowndataArr);
    let storeDataFinal = knowndata;
    widgetData = chunkArray(storeDataFinal, 3);
  } else {
    widgetData =  [];
    noDataOfKnownData = response.dataCount;
    if(!isDetailed) setNoDataOfKnownData(noDataOfKnownData);
  }

  if(!isDetailed) setWidgetData(widgetData); 
  return {widgetData , noDataOfKnownData};

}

const chunkArray = (ArrayData, chunk_size) => {
  var index = 0;
  var arrayLength = ArrayData.length;
  var tempArray = [];

  for (index = 0; index < arrayLength; index += chunk_size) {
    let myChunk = ArrayData.slice(index, index + chunk_size);
    // Do something if you want with the group
    tempArray.push(myChunk);
  }
  return tempArray;
}

export function splitDevelopmentData(widgetData){

    let knownDevSplit = 0;
    let kdExtraCount = 0;
    let knownDevArr = widgetData;
    let kdFormattedData = [];
    let kdFtData = [];
    let kdPageLength = 1;
    let kdNextpage = false;

    
    for (let knDev = 0; knDev < knownDevArr.length; knDev++) {
      kdNextpage = false;
      let tableSize = ["large", "medium", "small"];
      let knownAttrCount = knownDevArr[knDev].map(ft => Object.keys(ft).reduce((a, b) => a + (ft[b] ? b === "sourceurl" ? ft[b].split("; ").length : b === 'summary' ? ft[b]?.length ? Math.round(ft[b].length / 45) : 0 : 1 : 0), 0)).sort((a, b) => a > b ? -1 : 1)[0];
      if (kdPageLength !== 0 && knownAttrCount > 25 && knDev === 0) {
        kdExtraCount = knownAttrCount - 25;
        knownDevSplit = kdExtraCount > 6 ? 3 : 2;
      }
      else if (kdExtraCount > 0 && kdPageLength !== 0 && (knownAttrCount + kdExtraCount) > 40) {
        kdExtraCount = (knownAttrCount + kdExtraCount) - 40;
        knownDevSplit = kdExtraCount > 6 ? 3 : 2;
      }
      else {
        knownDevSplit = 1;
        kdExtraCount = 0;
        let extraCt = knDev === 0 ? 8 : kdExtraCount;
        if ((knownAttrCount + extraCt) > 40) {
          kdExtraCount = (knownAttrCount + extraCt) - 40;
          knownDevSplit = kdExtraCount > 6 ? 3 : 2;
        }
      }
      if (kdExtraCount > 12) {
        kdNextpage = true;
      }
      else if (kdExtraCount < 4) {
        knownDevSplit = 1;
        kdExtraCount = 0;
      }

      let kdLoopCount = knownDevSplit === 1 ? 1 : 2;
      for (let kdCount = 1; kdCount <= kdLoopCount; kdCount++) {
        if (kdNextpage || (kdExtraCount !== 0 && kdCount === 2)) {
          kdFormattedData.push(kdFtData);
          kdFtData = [];
        }
        kdFtData.push({ kdCount, tableSize: tableSize[knownDevSplit - 1], data: knownDevArr[knDev] });
        if (kdExtraCount === 0 || (kdLoopCount === kdCount && knDev === (knownDevArr.length - 1))) {
          kdFormattedData.push(kdFtData);
          kdFtData = [];
        }
      }
    }

    return kdFormattedData;

}

export function transactionSeperation(response){

  if (response.status === 200) {        

    let resData = response.data;
    let transAttrData = [];
    let transFormatData = [];
    let transContact = [];
    let contactKeyList = [];
    let propertyData = [];
    let transData = [];
    let transNoData = false;
    let attrCount = 45;

    const emptyData = (data) => {
      let dataDt = { ...data };
      for (const key in dataDt) dataDt[key] = null;
      return dataDt;
    }

    const getReferenceData = (data) => {
      let refData = [];
      if (data.length === 1) return data[0];
      for (let index = 1; index < data.length; index++) {
        if (index === 1) refData.push(...data[0]);

        let cmpObj1 = refData.length > data[index].length ? refData : data[index];
        let cmpObj2 = refData.length < data[index].length ? refData : data[index];
        let cmpData = [...cmpObj1];
        let cmpObj = cmpObj2.filter(ft => !cmpData.includes(ft));

        for (let index = 0; index < cmpObj.length; index++) {
          let pos = cmpObj2.findIndex(ft => ft === cmpObj[index]);
          let pos1 = cmpData.findIndex(ft => ft === cmpObj2[pos - 1]);
          let pos2 = -1;
          if (pos1 === -1) pos2 = cmpData.findIndex(ft => ft === cmpObj2[pos + 1]);
          let addpos = pos2 !== -1 ? (pos2 - 1) : pos1;
          cmpData.splice((addpos + 1), 0, cmpObj[index]);
        }
        refData = cmpData;
      }
      return refData;
    }

    if (resData?.properties?.length > 0) {
      let avoidAttr = ["id", "profileid", "saletypeid", "masterid", "facilityid", "profileid"];
      let properties = resData.properties;
      let transaction = resData.transactions;
      let contact = resData.transactioncontacts;
      let facility = resData.facilities;
      let deedInfo = resData.deedinfos;

      for (let p = 0; p < properties.length; p++) {
        let data = [];
        contactKeyList = [];
        let transDt = transaction.filter(ft => ft.profileid === properties[p].profileid);
        let contactDt = contact.filter(ft => ft.profileid === properties[p].profileid);
        let falcDt = facility.filter(ft => ft.profileid === properties[p].profileid);
        let deedDt = deedInfo.filter(ft => ft.profileid === properties[p].profileid);
        contactKeyList = contactDt?.map(dt => Object.keys(dt || {})
          .filter(ft => !avoidAttr.includes(ft) && dt[ft]))?.sort((a, b) => a.length > b.length ? -1 : 1)[0] ?? [];

        let transactionList = [];
        for (let i = 0; i < transDt.length; i++) {
          transContact = [];
          let deedData = deedDt.filter(ft => ft.id === transDt[i].id);
          let contactFt = contactDt.filter(ft => ft.id === transDt[i].id) ?? [];
          transContact.push(...(contactFt.length > 0 ? contactFt : contactDt.length > 0 ? [emptyData(contactDt[0])] : []));
          transactionList.push(transContact);
          let falcDtExist = falcDt?.map(dt => Object.keys(dt || {}).some(ft => !avoidAttr.includes(ft) && dt[ft]))?.includes(true);
          let falcFt = falcDt.length > 0 ? falcDt.filter(ft => ft.id === transDt[i].id) : [];
          let falcData = falcFt.length > 0 ? falcFt : [emptyData(falcDt[0])];

          data.push({
            ...({ mainHeader: `Transaction ${i + 1}`, ...transDt[i] }),
            ...({ transContactData: transContact }),
            ...([falcDt[0]]?.map(dt => Object.keys(dt || {}).filter(ft => !avoidAttr.includes(ft) && dt[ft]))[0]?.length > 0 || falcDtExist ? { facTitle: "ST", ...falcData[0] } : {}),
            ...([deedData[0]]?.map(dt => Object.keys(dt || {}).filter(ft => !avoidAttr.includes(ft) && dt[ft]))[0]?.length > 0 ? { deedTitle: "ST", ...deedData[0] } : {}),
          });
        }

        let existingData = data.map(dt => Object.keys(dt).filter(ft => !avoidAttr.includes(ft) && dt[ft]));
        let reference = getReferenceData(existingData);
        // let reference = existingData.sort((a, b) => a.length > b.length ? -1 : 1)[0];
        let noData = reference.length === 0;
        transAttrData = !noData ? [...reference] : [""];

        let contactIndex = transAttrData.findIndex(ci => ci === "transContactData");
        if (transContact.length > 0) {
          let transContactList = transactionList.sort((a, b) => a.length > b.length ? -1 : 1)[0];
          transAttrData.splice(contactIndex, 1);
          transAttrData.splice(contactIndex, 0, ("contactTitle"));
          let trCount = 1;
          for (let tcn = 0; tcn < transContactList.length; tcn++) {
            let contactCount = transContactList.length > 1 ? 1 : 0;
            if (contactCount) {
              transAttrData.splice((contactIndex + trCount), 0, ("Contact "));
              trCount += 1;
            }
            for (let ck = 0; ck < contactKeyList.length; ck++) {
              transAttrData.splice((contactIndex + trCount), 0, contactKeyList[ck]);
              trCount += 1;
            }
          }
        }
        else transAttrData.splice(contactIndex, 1);

        transData.push(...data);
        propertyData.push({ storeDetails: properties[p], attrData: transAttrData });
      }
    } else {
      transNoData = true;
    }

    if (!transNoData && resData.transactions.length > 0) {
      let ftData = [];

      for (let i = 0; i < propertyData.length; i++) {
        let pty = propertyData[i];
        let transDataCount = transData.filter(ft => ft.profileid === pty.storeDetails.profileid);
        let extra = transDataCount.map(dt => dt.investmenthighlights ? dt.investmenthighlights.length : 1).sort((a, b) => b - a)[0];
        attrCount = extra > 60 ? (attrCount - parseInt(extra / 60)) : attrCount
        let pageLength = pty.attrData.length;

        let splittedLength = Math.ceil(transDataCount.length / 3);

        for (let tr = 0; tr < splittedLength; tr++) {
          if (pageLength < attrCount) {
            attrCount = attrCount - pageLength - (i === 0 && tr === 0 ? 7 : 2);
            ftData.push({ ...pty, data: transDataCount.splice(0, 3) });
          }
          else {
            attrCount = 45;
            transFormatData.push(ftData);
            ftData = [];
            attrCount = attrCount - pageLength - 2;
            ftData.push({ ...pty, data: transDataCount.splice(0, 3) });
          }
        }
      }
      if (ftData.length > 0) transFormatData.push(ftData);
    }

    return {transFormatData , transNoData };

  }else{
    handlingCatchError(response);
    return null;
  } 

}


function roundOffFloatValue(floatNumber) {
  const number = floatNumber.toString();
  const [_, decimalPart] = number.split(".");

  // Count leading zeros in the decimal part
  let leadingZerosCount = (decimalPart.match(/^0+/) || [""])[0].length;

  // Convert to the correct number of decimal places (leading zeros + 1)
  let roundedValue = parseFloat(floatNumber).toFixed(leadingZerosCount + 1);

  return roundedValue
}

export function formatNumberForZeros(input) {
  const numStr = input.toString();

  if(numStr && !numStr.includes(".")) return numStr;

  // Handle numbers without decimal or with only trailing zeroes
  if (/^\d+(\.0+)?$/.test(numStr)) {
      return Number(input).toFixed(2);
  }

  // If decimal part starts with "00", return the number as-is
  if (numStr.includes('.')) {
      const [ _ , decimalPart] = numStr.split('.');

      // Check if the decimal part starts with "00"
      if (decimalPart.startsWith("00")) {
          return roundOffFloatValue(input); // Return the number as-is
      }

      // If there are more than 2 decimal places, round to 2 decimals
      if (decimalPart.length > 2) {
          return Number(input).toFixed(2);
      }
  }

  // Return the number as is for other cases
  return input;
}

export const updateObjectValues = (obj) => {
  if(!obj) return obj;

  // Iterate over each key in the object
  for (let key in obj) {
    const value = obj[key];
    // Check if the value contains only digits and a period
    if (value && /^[\d.]+$/.test(value)) {
      // If the value is valid, apply the formatting function
      obj[key] = formatNumberForZeros(value.toString());
    }
    obj[key] = obj[key] ? formatNumberWithCommas(obj[key]) : obj[key] ;
    // If the value contains anything else, leave it unchanged
  }

  return obj;
};

function formatNumberWithCommas(number) {
  try {
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ",");  
  } catch (error) {
    return number;
  }
}


export function commonFormatNumber(number){

  if(!number) return number;
  if(!isValidNumber(number.toString())) return number
  try {
    number = Number(number)
    const inputNumber = formatNumberForZeros(number);
    return formatNumberWithCommas(inputNumber);
    
  } catch (error) {
    return number;
  }

}

export function isValidNumber(str) {
  // This regular expression allows numbers and at most one dot
  const regex = /^[0-9]*\.?[0-9]+$/;
  return regex.test(str);
}

export function capitalizeFirstLetter(string) {
  try {
    return string.charAt(0).toUpperCase() + string.slice(1);
  } catch (error) {
    return string;
  }
}

export function isS3Url(url) {

  if(url){
    return url.includes('s3://');
  }
  return false;

}

export const getUserLogo = async (key , logo) => {
  try{
    let sKey = !key ? null : key;
  const res = await apiCommonTrigger("get" , Config.API_URL + "/markets/userlogo/" , [sKey])  
  if (res.status === 200) {
    const logoData = getImageSrc(res.data.userlogoblob);
    return logoData;
  } else {
    return logo;
  }
  }
  catch(error){ 
    handlingCatchError(error);
    return logo;
  }
};

export const removeKeys = (array, keys) => {

  if(!keys) return array;
  
  return array.map(obj => {
    const newObj = { ...obj };
    keys.forEach(key => {
      delete newObj[key]; // Remove the key from the object
    });
    return newObj;
  });
};

export const formatSeasonalityText = (text)=> {

  if(text){
    const updatedText = text.replace(/,/g, ', ');
    return updatedText;
  }

  return text;
}

export const CommonSearchFunction = (searchedText, usersSearchedData, searchedFieldsString) => {
  let value = typeof (searchedText) !== "string" ? searchedText : searchedText.trim();
  let convertedToString = String(value);
  if (convertedToString !== "") {
      let returnedArray = usersSearchedData.filter(filteredData => {
          for (let i = 0; i < searchedFieldsString.length; i++) {
              if (String(filteredData[searchedFieldsString[i]]).toLowerCase().includes(convertedToString.toLowerCase())) return filteredData;
          }
    
          return "";
      });
      return { data: returnedArray, isEmptyOrNot: "notEmpty" };
  } else return { data: "", isEmptyOrNot: "empty" };
}

export const checkImpersonation = () => {
    window.globalThis.REACT_SNACK_OPEN = true;
    window.globalThis.REACT_SNACK_MESSAGE = "Impersonated User";
    window.globalThis.REACT_SNACK_SEVERITY = "warning";

    const errorSnackBtn = document.getElementById("enable-error-snack");
    if (errorSnackBtn) {
      errorSnackBtn.click();
    }
    return;
  }

export const validateUrlElement = (url) => {
  // Ensure the URL is a string and trim any surrounding whitespace
  let sourceURL = url.toString().trim();

  // If the URL doesn't start with "http://" or "https://", prepend "http://"
  if (!/^https?:\/\//i.test(sourceURL)) {
    sourceURL = "http://" + sourceURL;
  }

  // Check if the URL is valid
  const isValid = isValidUrl(sourceURL);
  let urlValid = isValid ? new URL(sourceURL) : null;

  return (
    <a target="_blank" href={sourceURL}>
      {urlValid ? sourceURL : ""}
    </a>
  );
};



// cacheHelpers.js

const CACHE_NAME = 'rv-park'; // You can customize this

/**
* Store data in Cache Storage using a dynamic key
* @param {string} key - The dynamic key (e.g., '/user/123')
* @param {*} value - Any JSON-serializable value
*/
export const setCache = async (key, value) => {
try {
const cache = await caches.open(CACHE_NAME);
const response = new Response(JSON.stringify(value), {
headers: { 'Content-Type': 'application/json' },
});
await cache.put(new Request(key), response);
} catch (error) {
console.error('Failed to set cache:', error);
}
};

/**
* Retrieve data from Cache Storage using a dynamic key
* @param {string} key - The dynamic key (e.g., '/user/123')
* @returns {*} Parsed value from cache or null
*/
export const getCache = async (key) => {
try {
const cache = await caches.open(CACHE_NAME);
const cachedResponse = await cache.match(new Request(key));
if (!cachedResponse) return null;
const data = await cachedResponse.json();
return data;
} catch (error) {
console.error('Failed to get cache:', error);
return null;
}
};

export const deleteCache = async (key) => {
try {
const cache = await caches.open(CACHE_NAME);
const deleted = await cache.delete(new Request(key));
return deleted;
} catch (error) {
console.error('Failed to delete cache:', error);
return false;
}
};

const checkIsFilterApplied = (selectedFilters , defaultOptions) => {
  
  return true
}

const isExactWithoutInitialPins = (a, b, c) => {
  const filteredB = b.filter(item => !c.includes(item));
  const sortedA = [...a].sort((x, y) => x - y);
  const sortedFilteredB = filteredB.sort((x, y) => x - y);
  return (
    sortedA.length === sortedFilteredB.length &&
    sortedA.every((val, idx) => val === sortedFilteredB[idx])
  );
};

export const arraysHaveSameElements = (a, b) => {
  if (a.length !== b.length) return false;
  const sortedA = [...a].sort((x, y) => x - y);
  const sortedB = [...b].sort((x, y) => x - y);
  return sortedA.every((val, i) => val === sortedB[i]);
}

export const getTrafficLineWidth = zoomLevel => {
    return  zoomLevel < 10 ? 3 :
            zoomLevel < 11 ? 3 :
            zoomLevel < 12 ? 4 :
            zoomLevel < 13 ? 5 :
            zoomLevel < 14 ? 6 :
            zoomLevel < 15 ? 7 : 
            zoomLevel < 17 ? 9 :
            zoomLevel < 19 ? 14 : 15;
}

export const shouldUpdateBasedOnDistance = (map , prevCenterRef) => {
  const center = map.getCenter(); // current center {lat, lng}
  const zoom = map.getZoom();

  // 1. Skip updates if zoom < 14
  if (zoom < 14) return true;  
  let distanceKm = 0;

  if (prevCenterRef.current) {   
    // --- Calculate the distance in KM ---
    const R = 6371; // Radius of Earth in km
    const toRad = (deg) => deg * Math.PI / 180;

    const lat1 = prevCenterRef.current.lat;
    const lon1 = prevCenterRef.current.lng;
    const lat2 = center.lat;
    const lon2 = center.lng;

    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) ** 2;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    distanceKm = R * c; // in kilometers
  }

  if(distanceKm && distanceKm < 0.5 ){
    return false
  }

  prevCenterRef.current = center; 
  return true;
};
